/* UTILS */
import { useInfiniteQuery } from '@tanstack/vue-query';

/* API */
import { getMeNotifications } from '@/api/calls/me/me.api';
/* HELPERS */
import { getCacheDuration, getNextPageValue } from '@/api/helpers/helpers';

/* Notification vue queries */
export function useGetNotifications() {
  return useInfiniteQuery({
    queryKey: ['getMeNotifications'],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => getMeNotifications({ page: pageParam }),
    getNextPageParam: getNextPageValue,
    // options
    staleTime: getCacheDuration('x-long')
  });
}
